import React, { useContext, useState, useEffect } from 'react';

import Schema from 'src/partials/schema/offer';

const Start = ({ data }) => {

    return (
        <div>
            <Schema data={data}  />
        </div>
    );
};

export default Start;
